import {SponsorRole} from '../../_types/selectOptionsTypes/sponsorRole';

export const sponsorRoleOptions: Array<SponsorRole> = [
  {value: 'INVESTOR', label: 'Investor'},
  {value: 'OWNER_OCCUPIER', label: 'Owner occupier'},
];
